import {
  OrderStates,
  PartnerEshopAutomaticLabelsPrintSetup,
  PartnerEshopBankDetails,
  PartnerEshopCrossDock,
  PartnerEshopDefaults,
  PartnerEshopPricingEnablerSetup,
  PartnerEshopResponsibilities,
} from '../apiTypes';

export const mockGetPartnerEshopBankDetails: PartnerEshopBankDetails = {
  bankAccount: '111222333/444',
  bankAccountName: 'Joe Doe',
};

export const mockGetPartnerEshopDefaults: PartnerEshopDefaults = {
  defaultShippingRateId: '7470ffe8-8691-4c35-9f2b-a8e527b523bc',
  defaultReturnPolicyId: 'd1cbcd9e-6042-4b1b-8e4f-3ba00d94ed32',
  defaultWarrantyId: '9a908d1f-dd30-4c30-87ad-b82ce5d696b8',
};

export const mockGetPartnerCrossDock: PartnerEshopCrossDock = {
  enabled: true,
  code: 'OLZA-1',
};

export const mockPartnerEshopPricingEnablerSetup: PartnerEshopPricingEnablerSetup = {
  enabled: true,
  marketplaceCode: 'MALL.CZ',
};

export const mockGetPartnerEshopAutomaticLabelsPrintSetup: PartnerEshopAutomaticLabelsPrintSetup = {
  automaticLabelsPrintEnabled: true,
  automaticLabelsPrintOrderStatus: OrderStates.SHIPPING,
};

export const mockSavePartnerEshopAutomaticLabelsPrintSetup
: PartnerEshopAutomaticLabelsPrintSetup = {
  automaticLabelsPrintEnabled: true,
  automaticLabelsPrintOrderStatus: OrderStates.OPEN,
};

export const mockGetPartnerEshopResponsibilities: PartnerEshopResponsibilities = {
  defaultResponsiblePersonId: '9a908d1f-dd30-4c30-87ad-b82ce5d696b8',
  defaultResponsibleProducerId: '2a2dc574-2d4e-5d2f-b1d9-3d7f1e4b1f02',
};
